import { createContext } from 'react';
import { Store } from './createStore';

export type StoreContextValue = Store;

export const StoreContext = createContext<StoreContextValue | null>(null);
